// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"428":"214fddcb","494":"92df4360"}[chunkId] + ".chunk.js";
};